/** Окно выдачи постраничного списка: записи самого окна и общее число записей под тем же отбором */
export type ListWindow<TItem> = {
  /** Записи окна */
  items: TItem[];
  /** Всего записей под отбором — без учёта окна */
  total: number;
};

/**
 * Весь набор постраничного списка: сервер отдаёт его окнами и вместе с окном сообщает общее
 * число записей — окна запрашиваются подряд, пока набор не наберётся целиком.
 * Одним запросом с большим `limit` это не решается: `limit` — потолок выдачи, за которым
 * записи молча исчезают, а сервер выше своего предела окно не отдаёт.
 *
 * `maxLimit` — наибольшее окно, которое принимает эндпоинт списка: чем оно крупнее, тем меньше запросов.
 */
export const fetchAllPages = async <TItem>(
  fetchWindow: (offset: number, limit: number) => Promise<ListWindow<TItem>>,
  maxLimit: number,
): Promise<ListWindow<TItem>> => {
  const items: TItem[] = [];
  let total = 0;

  do {
    const page = await fetchWindow(items.length, maxLimit);
    total = page.total;
    // Окно без записей при незакрытом наборе — расхождение выдачи и счётчика на сервере;
    // без этого выхода запрос за тем же смещением повторялся бы бесконечно
    if (page.items.length === 0) break;
    items.push(...page.items);
  } while (items.length < total);

  return { items, total };
};
